/* eslint-disable no-dupe-keys */
export default [
  {
    _id: 'd01fa76b-0629-42a8-a10f-57b91e5d623e',
    templateIndex: '211',
    title: 'Jajanan Indo',
    position: 180,
    versions: [
      {
        _id: '9dfdc00e-a08f-47ca-8a35-a269f21a36d1',
        templateIndex: '211',
        title: 'Jajanan Indo',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'jajanan-indo',
        categories: [],
        src: {
          name: 'jajanan-indo.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e12d7a77-3e1c-4a3a-9220-ebb1e8903785',
        templateIndex: '211',
        title: 'Jajanan Indo Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'jajanan-indo-single-page',
        categories: [],
        src: {
          name: 'jajanan-indo-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['id'],
  },
  {
    _id: '4ee43314-14a9-4838-87ed-579ba374ef42',
    templateIndex: '311',
    title: 'Funeral Services',
    position: 179,
    versions: [
      {
        _id: '385c3a09-327e-4800-a8e3-4b733347bb10',
        templateIndex: '311',
        title: 'Funeral Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'funeral-services',
        categories: [],
        src: {
          name: 'funeral-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '69f0a115-8a6a-4f96-a01c-55b7d4272e5d',
        templateIndex: '311',
        title: 'Funeral Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'funeral-services-single-page',
        categories: [],
        src: {
          name: 'funeral-services-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'ac2d6544-24b2-4173-ba75-05dd97823999',
    templateIndex: '110',
    title: 'Writer',
    position: 178,
    versions: [
      {
        _id: 'ac2d6544-24b2-4173-ba75-05dd97823999',
        title: 'Writer',
        templateIndex: '110',
        type: 'multiPages',
        link: 'writer',
        categories: [
          '574ec1f901e9d73bfb5d9939',
          '574ec21f01e9d73bfb5d993b',
          '58637d12d7bf940e2080e185',
        ],
        src: {
          name: 'writer.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'd1c99546-1f95-4517-a3f9-d7707ec7cd70',
        versionName: 'onePage',
        title: 'Writer Single-Page',
        templateIndex: '110',
        type: 'onePage',
        link: 'writer-single-page',
        categories: [],
        src: {
          name: 'writer-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Portfolio', 'Personal', 'All'],
    src: {
      name: 'writer.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '3c20b53d-381f-41a8-8ea5-32790b50bef1',
    templateIndex: '202',
    title: 'Bali High Living',
    position: 177,
    versions: [
      {
        _id: 'd087b90d-7cad-47fe-bf3c-4ec04a2cefbc',
        templateIndex: '202',
        title: 'Bali High Living Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'bali-high-living-single-page',
        categories: [],
        src: {
          name: 'bali-high-living.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '3c20b53d-381f-41a8-8ea5-32790b50bef1',
        templateIndex: '202',
        title: 'Bali High Living',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'bali-high-living',
        categories: [],
        src: {
          name: 'bali-high-living.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'bali-high-living.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: '52d14b5a-2f5a-4bd5-b760-49189e243ba4',
    templateIndex: '226',
    title: 'App Landing Page',
    position: 176,
    versions: [
      {
        _id: '52d14b5a-2f5a-4bd5-b760-49189e243ba4',
        templateIndex: '226',
        title: 'App Landing Page',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'app-landing-page',
        categories: [],
        src: {
          name: 'app-landing-page.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '2542bbdb-0ed8-483a-b5b9-d188bbb11e9a',
        templateIndex: '226',
        title: 'App Landing Page Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'app-landing-page-single-page',
        categories: [],
        src: {
          name: 'app-landing-page-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'app-landing-page.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '6b287f19-e5ff-4c2b-a3d4-8d25dd48c0fa',
    templateIndex: '222',
    title: 'Landscape Photographer',
    position: 175,
    versions: [
      {
        _id: '6b287f19-e5ff-4c2b-a3d4-8d25dd48c0fa',
        templateIndex: '222',
        title: 'Landscape Photographer',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'landscape-photographer',
        categories: [],
        src: {
          name: 'landscape-photographer.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '0c7e6e05-f2fd-422e-a5f1-21014aebe8fc',
        templateIndex: '222',
        title: 'Landscape Photographer Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'landscape-photographer-single-page',
        categories: [],
        src: {
          name: 'landscape-photographer-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    src: {
      name: 'landscape-photographer.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'fbfea198-5d27-47f4-a9f8-7ea73611c613',
    templateIndex: '309',
    title: 'Equipment Rental',
    position: 174,
    versions: [
      {
        _id: 'b399d9b1-42df-4650-b2c1-2776868be925',
        templateIndex: '309',
        title: 'Equipment Rental',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'equipment-rental',
        categories: [],
        src: {
          name: 'equipment-rental.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '6db5be03-d5a0-4f9f-ba60-b2e22988af85',
        templateIndex: '309',
        title: 'Equipment Rental Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'equipment-rental-single-page',
        categories: [],
        src: {
          name: 'equipment-rental-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '9dd39b45-5f7c-4e82-8a2b-61b8a74a5124',
    templateIndex: '310',
    title: 'Agriculture',
    position: 173,
    versions: [
      {
        _id: 'a2d742bd-8e9e-428e-a50d-ee63de3c9ad7',
        templateIndex: '310',
        title: 'Agriculture',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'agriculture',
        categories: [],
        src: {
          name: 'agriculture.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'de6b64c4-6aa2-4f6e-bfbf-943e1d288dda',
        templateIndex: '310',
        title: 'Agriculture Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'agriculture-single-page',
        categories: [],
        src: {
          name: 'agriculture-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '3ad25ecc-4612-4c02-a7a1-455b5ba28c57',
    templateIndex: '197',
    title: 'Toko Hijab',
    position: 172,
    versions: [
      {
        _id: '3ad25ecc-4612-4c02-a7a1-455b5ba28c57',
        templateIndex: '197',
        title: 'Toko Hijab Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'toko-hijab-single-page',
        categories: [],
        src: {
          name: 'toko-hijab-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'toko-hijab-single-page.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['id'],
  },
  {
    _id: 'e68e1e45-bdb6-44bc-9f52-1878f5bfbc6c',
    templateIndex: '191',
    title: 'Fotografi',
    position: 171,
    versions: [
      {
        _id: 'e68e1e45-bdb6-44bc-9f52-1878f5bfbc6c',
        templateIndex: '191',
        title: 'Fotografi',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fotografi',
        categories: [],
        src: {
          name: 'fotografi.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '3f524bca-097e-4baa-b437-602a0d363efc',
        templateIndex: '191',
        title: 'Fotografi Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fotografi-single-page',
        categories: [],
        src: {
          name: 'fotografi-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    src: {
      name: 'fotografi.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'd75b4824-292d-4cf7-9bfa-5bd81c1abb1e',
    templateIndex: '307',
    title: 'Mobile App',
    position: 170,
    versions: [
      {
        _id: '2c397f74-badd-4703-81e5-9543b3daa660',
        templateIndex: '307',
        title: 'Mobile App',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'mobile-app',
        categories: [],
        src: {
          name: 'mobile-app.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '934324b4-26c2-4034-9eb0-3c9786aa86de',
        templateIndex: '307',
        title: 'Mobile App Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'mobile-app-single-page',
        categories: [],
        src: {
          name: 'mobile-app-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'a48fee4d-8375-447c-a5c2-ac668437acfa',
    templateIndex: '205',
    title: 'Indah Alami',
    position: 169,
    versions: [
      {
        _id: 'a48fee4d-8375-447c-a5c2-ac668437acfa',
        templateIndex: '205',
        title: 'Indah Alami',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'indah-alami',
        categories: [],
        src: {
          name: 'indah-alami.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'c3db0d7c-3a08-4618-92b7-bda72ea745e5',
        templateIndex: '205',
        title: 'Indah Alami Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'indah-alami-single-page',
        categories: [],
        src: {
          name: 'indah-alami-singlepage',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health', 'Beauty'],
    src: {
      name: 'indahalami.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'd304342b-4fd4-446c-8bc2-88325035b783',
    templateIndex: '301',
    title: 'Portfolio',
    position: 168,
    versions: [
      {
        _id: '437cb9c6-8229-4123-bfd4-7360a92c286f',
        templateIndex: '301',
        title: 'Portfolio',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'portfolio',
        categories: [],
        src: {
          name: 'portfolio.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '3d7c564a-0e5e-43d1-9009-54a2512a5089',
        templateIndex: '301',
        title: 'Portfolio Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'portfolio-single-page',
        categories: [],
        src: {
          name: 'portfolio-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    locale: ['en'],
  },
  {
    _id: '3efd9e50-7aa8-4e25-9705-db11ff24229d',
    templateIndex: '305',
    title: 'Rock Band',
    position: 167,
    versions: [
      {
        _id: '509ad2fc-1277-4f0a-9514-fd1f8a285084',
        templateIndex: '305',
        title: 'Rock Band',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'rock-band',
        categories: [],
        src: {
          name: 'rock-band.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '5d5e0cfd-d1f0-49be-9b46-634582ebeaa2',
        templateIndex: '305',
        title: 'Rock Band Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'rock-band-single-page',
        categories: [],
        src: {
          name: 'rock-band-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    locale: ['en'],
  },
  {
    _id: '30fda364-08ba-4ea4-a71d-c07d8e9f13b7',
    templateIndex: '282',
    title: 'Beauty Salon',
    position: 166,
    versions: [
      {
        _id: '574b3b09-336b-4053-9393-f20f4b1cbbff',
        templateIndex: '282',
        title: 'Beauty Salon',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'beauty-salon',
        categories: [],
        src: {
          name: 'beauty-salon.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '7bf92a07-c03e-4eb8-abf8-56244f788b74',
        templateIndex: '282',
        title: 'Beauty Salon Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'beauty-salon-single-page',
        categories: [],
        src: {
          name: 'beauty-salon-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    locale: ['en'],
  },
  {
    _id: '6354ae87-5a42-44ff-9614-b5c6ef4c45a4',
    templateIndex: '295',
    title: 'IT Services',
    position: 165,
    versions: [
      {
        _id: 'd3f183e3-2917-4976-975e-91f1b982ecc5',
        templateIndex: '295',
        title: 'IT Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'it-services',
        categories: [],
        src: {
          name: 'it-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8f218a7f-40d5-4e0f-970a-194eef60e4c3',
        templateIndex: '295',
        title: 'IT Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'it-services-single-page',
        categories: [],
        src: {
          name: 'itservices-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'c330e38f-9806-4732-ac89-d31cdd715a33',
    templateIndex: '204',
    title: 'Visit Komodo',
    position: 164,
    versions: [
      {
        _id: '635fef66-ee81-49bf-88a3-d1c56d5a2b46',
        templateIndex: '204',
        title: 'Visit Komodo',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'visit-komodo',
        categories: [],
        src: {
          name: 'visit-komodo.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '08168482-204c-4fee-b5c9-c18dad946991',
        templateIndex: '204',
        title: 'Visit Komodo Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'visit-komodo-single-page',
        categories: [],
        src: {
          name: 'visit-komodo-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['id'],
  },
  {
    _id: 'edb2b3a5-8b79-4264-98c1-eaea8e80eb54',
    templateIndex: '298',
    title: 'Digital Agency',
    position: 163,
    versions: [
      {
        _id: 'd138faf3-3c1a-4006-b654-02024960f693',
        templateIndex: '298',
        title: 'Digital Agency',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'digital-agency',
        categories: [],
        src: {
          name: 'digital-agency.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e8a87c26-2ecf-47c2-abc5-8f30eb715eca',
        templateIndex: '298',
        title: 'Digital Agency Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'digital-agency-single-page',
        categories: [],
        src: {
          name: 'digital-agency-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '2d70fb3a-e212-44d0-93b6-3cebd4a4729f',
    templateIndex: '199',
    title: 'Furniture Collection',
    position: 162,
    versions: [
      {
        _id: '2d70fb3a-e212-44d0-93b6-3cebd4a4729f',
        templateIndex: '199',
        title: 'Furniture Collection',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'furniture-collection',
        categories: [],
        src: {
          name: 'furniture-collection.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8e38ea0a-60ec-4f99-bf5e-8e0f418372e6',
        templateIndex: '199',
        title: 'Furniture Collection Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'furniture-collection-single-page',
        categories: [],
        src: {
          name: 'furniture-collection-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'furniture-collection.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '762bc3b9-6072-41ba-b1b6-29dffa8daff0',
    templateIndex: '118',
    title: 'Artist',
    position: 161,
    versions: [
      {
        _id: '762bc3b9-6072-41ba-b1b6-29dffa8daff0',
        title: 'Artist',
        templateIndex: '118',
        type: 'multiPages',
        link: 'artist',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec21f01e9d73bfb5d993b',
          '574ec1f901e9d73bfb5d9939',
        ],
        src: {
          name: 'artist.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '113d6e9f-ead4-42d8-9063-129c84c94fa4',
        versionName: 'onePage',
        title: 'Artist Single-Page',
        templateIndex: '118',
        type: 'onePage',
        link: 'artist-single-page',
        categories: [],
        src: {
          name: 'artist.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Personal', 'Portfolio'],
    src: {
      name: 'artist.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'a8d6b9a5-2845-4a68-801a-c0e8609cd0a9',
    templateIndex: '299',
    title: 'Consultant',
    position: 160,
    versions: [
      {
        _id: 'f8484443-5633-4225-8b6f-e2b2f13340e5',
        templateIndex: '299',
        title: 'Consultant',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'consultant',
        categories: [],
        src: {
          name: 'consultant.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '5771eef1-f830-410f-9250-e9428433cff8',
        templateIndex: '299',
        title: 'Consultant Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'consultant-single-page',
        categories: [],
        src: {
          name: 'consultant-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'b3f9f398-de4b-4ef1-beec-5a5a94618818',
    templateIndex: '196',
    title: 'Toko Online',
    position: 159,
    versions: [
      {
        _id: 'b3f9f398-de4b-4ef1-beec-5a5a94618818',
        templateIndex: '196',
        title: 'Toko Online Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'toko-online-single-page',
        categories: [],
        src: {
          name: 'toko-online-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'toko-online-single-page.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['id'],
  },
  {
    _id: '3874e845-61bc-4945-985a-978ded199ff4',
    templateIndex: '302',
    title: 'Life Coach',
    position: 158,
    versions: [
      {
        _id: '739f2182-f472-49ac-a14d-93916eb3d35f',
        templateIndex: '302',
        title: 'Life Coach',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'life-coach',
        categories: [],
        src: {
          name: 'life-coach.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '680c8f1b-406c-4929-93f7-bd431d77dd6f',
        templateIndex: '302',
        title: 'Life Coach Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'life-coach-single-page',
        categories: [],
        src: {
          name: 'lifecoach-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'a51a5522-9f2e-412b-8288-94306ea17886',
    templateIndex: '172',
    title: 'Travel Tours',
    position: 157,
    versions: [
      {
        _id: 'a51a5522-9f2e-412b-8288-94306ea17886',
        title: 'Travel Tours',
        templateIndex: '172',
        type: 'multiPages',
        link: 'travel-tours',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'travel-tours.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '7145606f-7e84-4923-89ac-82ef567da9f4',
        versionName: 'onePage',
        title: 'Travel Tours Single-Page',
        templateIndex: '172',
        type: 'onePage',
        link: 'travel-tours-single-page',
        categories: [],
        src: {
          name: 'traveltours-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'traveltours.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'de743042-79b1-4c60-a7f4-98a1c69454ee',
    templateIndex: '170',
    title: 'Bakery',
    position: 156,
    versions: [
      {
        _id: 'de743042-79b1-4c60-a7f4-98a1c69454ee',
        title: 'Bakery',
        templateIndex: '170',
        type: 'multiPages',
        link: 'bakery',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec22701e9d73bfb5d993d',
          '574ec0f301e9d73bfb5d9937',
        ],
        src: {
          name: 'bakery.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '2754c07f-ed5f-466e-9868-bf06255b6219',
        versionName: 'onePage',
        title: 'Bakery Single-Page',
        templateIndex: '170',
        type: 'onePage',
        link: 'bakery-single-page',
        categories: [],
        src: {
          name: 'bakery-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'bakery.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'dc9058e3-307d-44ba-b760-532e862a92b6',
    templateIndex: '308',
    title: 'Charity',
    position: 155,
    versions: [
      {
        _id: '625cf5f4-50e4-4e35-b3af-13c1252bf958',
        templateIndex: '308',
        title: 'Charity',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'charity',
        categories: [],
        src: {
          name: 'charity.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'c926eee2-cbe9-408f-aca9-2b4ebe38c241',
        templateIndex: '308',
        title: 'Charity Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'charity-single-page',
        categories: [],
        src: {
          name: 'charity-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '3e992d6f-36f9-4eae-822b-2cff1eb8441f',
    templateIndex: '312',
    title: 'Product Page',
    position: 154,
    versions: [
      {
        _id: '2a9d1797-16a9-40d2-825d-2d6106fb5f6d',
        templateIndex: '312',
        title: 'Product Page',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'product-page',
        categories: [],
        src: {
          name: 'product-page.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'ec4b58aa-1648-4696-b71b-cb320c934514',
        templateIndex: '312',
        title: 'Product Page Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'product-page-single-page',
        categories: [],
        src: {
          name: 'product-page-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'e5d6317b-45d7-40dd-8b10-70b963ca0c13',
    templateIndex: '224',
    title: 'Physiotherapist',
    position: 153,
    versions: [
      {
        _id: 'e5d6317b-45d7-40dd-8b10-70b963ca0c13',
        templateIndex: '224',
        title: 'Physiotherapist',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'physiotherapist',
        categories: [],
        src: {
          name: 'physiotherapist.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '224a7405-81e4-41b7-8df8-887f17a6c5e8',
        templateIndex: '224',
        title: 'Physiotherapist Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'physiotherapist-single-page',
        categories: [],
        src: {
          name: 'physiotherapist-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'physiotherapist.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '10aec328-4c56-49e1-b968-b17a1d7e3d84',
    templateIndex: '190',
    title: 'Bisnis',
    position: 152,
    versions: [
      {
        _id: '10aec328-4c56-49e1-b968-b17a1d7e3d84',
        templateIndex: '190',
        title: 'Bisnis',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'bisnis',
        categories: [],
        src: {
          name: 'bisnis.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '57ff9c6b-ffbe-420c-9df1-193c127f94da',
        templateIndex: '190',
        title: 'Bisnis Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'bisnis-single-page',
        categories: [],
        src: {
          name: 'bisnis-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'bisnis.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: '0dd9b21e-0bd1-46c4-b50a-f737e74be26e',
    templateIndex: '200',
    title: 'Creative Portfolio',
    position: 151,
    versions: [
      {
        _id: 'cbb69e92-abf0-40b9-9beb-a575f2520716',
        templateIndex: '200',
        title: 'Creative Portfolio Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'creative-portfolio-single-page',
        categories: [],
        src: {
          name: 'creative-portfolio.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '113a506c-97c0-4674-976b-3487118f0d2a',
        templateIndex: '200',
        title: 'Creative Portfolio',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'creative-portfolio',
        categories: [],
        src: {
          name: 'creative-portfolio.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    locale: ['en'],
  },
  {
    _id: '74108b48-4097-4694-b4d4-578f35015a9a',
    templateIndex: '208',
    title: 'Jelajah Rinjani',
    position: 150,
    versions: [
      {
        _id: '7498e824-6041-4a9f-878a-db7a60306d45',
        templateIndex: '208',
        title: 'Jelajah Rinjani',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'jelajah-rinjani',
        categories: [],
        src: {
          name: 'jelajah-rinjani.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'eed85bf4-dffd-4443-bc82-e8aced4b6ea0',
        templateIndex: '208',
        title: 'Jelajah Rinjani Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'jelajah-rinjani-single-page',
        categories: [],
        src: {
          name: 'jelajah-rinjani-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    locale: ['id'],
  },
  {
    _id: '5d56c204-0b7a-4802-a693-d39ef8985124',
    templateIndex: '287',
    title: 'Fashion Designer',
    position: 149,
    versions: [
      {
        _id: '844299b1-58e4-43aa-bb1a-10525c096c77',
        templateIndex: '287',
        title: 'Fashion Designer',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fashion-designer',
        categories: [],
        src: {
          name: 'fashion-designer.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '5bf7ebba-12a9-44fd-8120-850ddc9aec26',
        templateIndex: '287',
        title: 'Fashion Designer Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fashion-designer-single-page',
        categories: [],
        src: {
          name: 'fashion-designer-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '9387ea0f-15c6-4aaa-8178-003db8015747',
    templateIndex: '303',
    title: 'Academic Tutoring',
    position: 148,
    versions: [
      {
        _id: 'e9b7bc9e-e1e8-4250-a997-49f207283b53',
        templateIndex: '303',
        title: 'Academic Tutoring',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'academic-tutoring',
        categories: [],
        src: {
          name: 'academictutoring.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '4f0f076b-616b-4506-8863-81a1de873cd1',
        templateIndex: '303',
        title: 'Academic Tutoring Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'academic-tutoring-single-page',
        categories: [],
        src: {
          name: 'academictutoring-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '75c3f3ca-6f74-41b8-a925-0b6e32b567e9',
    templateIndex: '248',
    title: 'Fashion Collection',
    position: 147,
    versions: [
      {
        _id: '274b22b6-e634-43c8-ac06-4041019ee5ea',
        templateIndex: '248',
        title: 'Fashion Collection',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fashion-collection',
        categories: [],
        src: {
          name: 'fashion-collection.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '44ad6039-7a55-401a-80c7-fa5c4c24ba78',
        templateIndex: '248',
        title: 'Fashion Collection Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fashion-collection-single-page',
        categories: [],
        src: {
          name: 'fashion-collection-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'fdb73fad-7ecf-4cef-ad4d-85066613bee2',
    templateIndex: '306',
    title: 'Logistics',
    position: 146,
    versions: [
      {
        _id: '4c7d8cb9-2466-450e-adba-c653022ff333',
        templateIndex: '306',
        title: 'Logistics',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'logistics',
        categories: [],
        src: {
          name: 'logistics.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8c73626c-9fa3-4850-ae48-837cb978ff74',
        templateIndex: '306',
        title: 'Logistics Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'logistics-single-page',
        categories: [],
        src: {
          name: 'logistics-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'd42803ce-d467-49d6-9efa-d5ff1cdb7c5f',
    templateIndex: '146',
    title: 'Blog Page',
    position: 145,
    versions: [
      {
        _id: 'd42803ce-d467-49d6-9efa-d5ff1cdb7c5f',
        title: 'Blog Page',
        templateIndex: '146',
        type: 'multiPages',
        link: 'blog-page',
        categories: ['58637d12d7bf940e2080e185', '574ec22a01e9d73bfb5d993e'],
        src: {
          name: 'blog-page.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '275d0ed2-edf7-4375-a204-9ea97a86e4f3',
        versionName: 'onePage',
        title: 'Blog Page Single-Page',
        templateIndex: '146',
        type: 'onePage',
        link: 'blog-page-single-page',
        categories: [],
        src: {
          name: 'blog-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    src: {
      name: 'blog-page.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '8fd360e8-5b4d-4a25-ae09-a9ec074c518a',
    templateIndex: '181',
    title: 'Makeup Artist',
    position: 144,
    versions: [
      {
        _id: '57fa19b2-df2f-47a7-8e4d-6a7bcbe6637b',
        templateIndex: '181',
        title: 'Makeup Artist Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'makeup-artist-single-page',
        categories: [],
        src: {
          name: 'makeup-artist.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8fd360e8-5b4d-4a25-ae09-a9ec074c518a',
        templateIndex: '181',
        title: 'Makeup Artist',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'makeup-artist',
        categories: [],
        src: {
          name: 'makeup-artist.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    src: {
      name: 'makeup-artist.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '63889746-0de1-4b70-8728-cb73e2c13986',
    templateIndex: '304',
    title: 'Cosmetic Surgery',
    position: 143,
    versions: [
      {
        _id: 'ea528032-68c1-4756-839c-95dcb3179d80',
        templateIndex: '304',
        title: 'Cosmetic Surgery',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'cosmetic-surgery',
        categories: [],
        src: {
          name: 'cosmetic-surgery.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'bc539373-cb73-4fda-8895-fe092f148bc6',
        templateIndex: '304',
        title: 'Cosmetic Surgery Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'cosmetic-surgery-single-page',
        categories: [],
        src: {
          name: 'cosmetic-surgery-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    locale: ['en'],
  },
  {
    _id: 'f2df1226-eaf3-48ce-ab9e-97ae5a53fd11',
    templateIndex: '139',
    title: 'Interior Designer',
    position: 142,
    versions: [
      {
        _id: 'f2df1226-eaf3-48ce-ab9e-97ae5a53fd11',
        title: 'Interior Designer',
        templateIndex: '139',
        type: 'multiPages',
        link: 'interior-designer',
        categories: [
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
          '58637d12d7bf940e2080e185',
        ],
        src: {
          name: 'interior-designer.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'dcf6d0fd-a51b-43d2-99a6-0584a100a7c1',
        versionName: 'onePage',
        title: 'Interior Designer Single-Page',
        templateIndex: '139',
        type: 'onePage',
        link: 'interior-designer-single-page',
        categories: [],
        src: {
          name: 'interior-designer-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Business', 'Services', 'All'],
    src: {
      name: 'interior-designer.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '0324ceec-ee80-4ce3-9563-b30220f4752d',
    templateIndex: '184',
    title: 'Grocery Store',
    position: 141,
    versions: [
      {
        _id: '0324ceec-ee80-4ce3-9563-b30220f4752d',
        templateIndex: '184',
        title: 'Grocery Store Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'grocery-store-single-page',
        categories: [],
        src: {
          name: 'grocery-store-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'grocery-store-single-page.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['en'],
  },
  {
    _id: '9b9318e2-0f7e-4107-8494-bbbc6f18b16e',
    templateIndex: '121',
    title: 'Property Manager',
    position: 140,
    versions: [
      {
        _id: '9b9318e2-0f7e-4107-8494-bbbc6f18b16e',
        title: 'Property Manager',
        templateIndex: '121',
        type: 'multiPages',
        link: 'property-management',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'property-management.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'f65a4a95-6dd2-4fbf-be0d-4cb390e82218',
        versionName: 'onePage',
        title: 'Property Manager Single-Page',
        templateIndex: '121',
        type: 'onePage',
        link: 'property-management-single-page',
        categories: [],
        src: {
          name: 'property-management-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'property-management.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '90e2785e-471c-49a2-a777-6bd022a856eb',
    templateIndex: '275',
    title: 'Interior Collections',
    position: 139,
    versions: [
      {
        _id: '972ad517-8306-46b0-a0a1-668994619f49',
        templateIndex: '275',
        title: 'Interior Collections',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'interior-collections',
        categories: [],
        src: {
          name: 'interior-collections.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '95081f44-1f3b-456a-a900-3bf49a5a7395',
        templateIndex: '275',
        title: 'Interior Collections Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'interior-collections-single-page',
        categories: [],
        src: {
          name: 'interior-collections-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'e2f90821-4594-4aec-ae18-e81d652aaa11',
    templateIndex: '145',
    title: 'Car Rental',
    position: 138,
    versions: [
      {
        _id: 'e2f90821-4594-4aec-ae18-e81d652aaa11',
        title: 'Car Rental',
        templateIndex: '145',
        type: 'multiPages',
        link: 'car-rental',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'car-rental.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'e11566d4-9900-4c57-a699-5561d8dd8ad2',
        versionName: 'onePage',
        title: 'Car Rental Single-Page',
        templateIndex: '145',
        type: 'onePage',
        link: 'car-rental-single-page',
        categories: [],
        src: {
          name: 'ca-rrental-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'car-rental.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'bf24d39d-9799-44ae-96a3-0b26c5ba5dfe',
    templateIndex: '223',
    title: 'Carpenter',
    position: 137,
    versions: [
      {
        _id: 'bf24d39d-9799-44ae-96a3-0b26c5ba5dfe',
        templateIndex: '223',
        title: 'Carpenter',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'carpenter',
        categories: [],
        src: {
          name: 'carpenter.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b0c5d20d-829c-4d4a-9404-afa8945b6f57',
        templateIndex: '223',
        title: 'Carpenter Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'carpenter-single-page',
        categories: [],
        src: {
          name: 'carpenter-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    src: {
      name: 'carpenter.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'e3bb18ca-3a6c-487a-8ae3-0f00a6c8559e',
    templateIndex: '203',
    title: 'Wunder Blooms',
    position: 136,
    versions: [
      {
        _id: '26ffd417-180d-449e-9a7e-ccc6758b74e4',
        templateIndex: '203',
        title: 'Wunder Blooms',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'wunder-blooms',
        categories: [],
        src: {
          name: 'wunder-blooms.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '57fae710-5da7-4b69-92de-aa80c402d012',
        templateIndex: '203',
        title: 'Wunder Blooms Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'wunder-blooms-single-page',
        categories: [],
        src: {
          name: 'wunder-blooms-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['id'],
  },
  {
    _id: '77c758c9-8204-4f9f-8bca-e1083d7716e9',
    templateIndex: '220',
    title: 'Handyman',
    position: 135,
    versions: [
      {
        _id: '77c758c9-8204-4f9f-8bca-e1083d7716e9',
        templateIndex: '220',
        title: 'Handyman',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'handyman',
        categories: [],
        src: {
          name: 'handyman.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f5398072-72cd-4f02-a682-85878e180eec',
        templateIndex: '220',
        title: 'Handyman Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'handyman-single-page',
        categories: [],
        src: {
          name: 'handyman-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    src: {
      name: 'handyman.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '11f6b5f8-0633-416c-9b73-ef5f57fc7e12',
    templateIndex: '297',
    title: 'Sushi Restaurant',
    position: 134,
    versions: [
      {
        _id: 'd4eeda1e-ebb1-4fa0-a737-4a30d53a86a5',
        templateIndex: '297',
        title: 'Sushi Restaurant',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'sushi-restaurant',
        categories: [],
        src: {
          name: 'sushi-restaurant.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '66d8145b-7962-41cf-849a-9461f3730916',
        templateIndex: '297',
        title: 'Sushi Restaurant Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'sushi-restaurant-single-page',
        categories: [],
        src: {
          name: 'sushi-restaurant-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: 'e44c00af-6379-4cc6-bfd1-52f541f0facf',
    templateIndex: '286',
    title: 'Smash Repairs',
    position: 133,
    versions: [
      {
        _id: '851066f5-165b-4299-91ce-d3ac8f80d490',
        templateIndex: '286',
        title: 'Smash Repairs',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'smash-repairs',
        categories: [],
        src: {
          name: 'smash-repairs.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'd5eff1f2-4429-4fdb-aa86-c27fff74378f',
        templateIndex: '286',
        title: 'Smash Repairs Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'smash-repairs-single-page',
        categories: [],
        src: {
          name: 'smash-repairs-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '010e7aa4-51aa-45d6-8fe8-74bfe6438779',
    templateIndex: '133',
    title: 'Home Builders',
    position: 132,
    versions: [
      {
        _id: '010e7aa4-51aa-45d6-8fe8-74bfe6438779',
        title: 'Home Builders',
        templateIndex: '133',
        type: 'multiPages',
        link: 'home-builders',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'home-builders.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '1e5efb78-b122-42fb-8df2-958190fb04f7',
        versionName: 'onePage',
        title: 'Home Builders Single-Page',
        templateIndex: '133',
        type: 'onePage',
        link: 'home-builders-single-page',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'home-builders.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'home-builders.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'e4d475f3-119b-45dd-9599-451c20c69f74',
    templateIndex: '289',
    title: 'Marketing Agency',
    position: 131,
    versions: [
      {
        _id: 'c94cee1c-933d-46cb-826d-8a2cd9bded3d',
        templateIndex: '289',
        title: 'Marketing Agency',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'marketing-agency',
        categories: [],
        src: {
          name: 'marketing-agency.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '2f5b43b4-1846-471b-80a2-c5fd6c83c712',
        templateIndex: '289',
        title: 'Marketing Agency Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'marketing-agency-single-page',
        categories: [],
        src: {
          name: 'marketing-agency-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  // {
  //   "_id": "f5c5d086-f89d-4f0e-906d-101b1b81b428",
  //   "templateIndex": "254",
  //   "title": "Photographer",
  //   "position": 130,
  //   "versions": [
  //     {
  //       "_id": "a025259e-8859-46ed-b9bb-049abaff44ad",
  //       "templateIndex": "254",
  //       "title": "Photographer",
  //       "versionName": "multiPages",
  //       "type": "multiPages",
  //       "link": "photographer",
  //       "categories": [],
  //       "src": {
  //         "name": "photographer.jpg",
  //         "path": "/assets/image"
  //       }
  //     },
  //     {
  //       "_id": "c7f409fc-e429-4c4c-9eb8-edc9663d53f0",
  //       "templateIndex": "254",
  //       "title": "Photographer Single-Page",
  //       "versionName": "onePage",
  //       "type": "onePage",
  //       "link": "photographer-single-page",
  //       "categories": [],
  //       "src": {
  //         "name": "photographer-singlepage.jpg",
  //         "path": "/assets/image"
  //       }
  //     }
  //   ],
  //   "categories": [
  //     "All",
  //     "Services",
  //     "Portfolio"
  //   ],
  //   "locale": [
  //     "en"
  //   ]
  // },
  {
    _id: '44b07e09-90cf-499d-99f5-541c41342ec6',
    templateIndex: '189',
    title: 'Liburan',
    position: 129,
    versions: [
      {
        _id: '44b07e09-90cf-499d-99f5-541c41342ec6',
        templateIndex: '189',
        title: 'Liburan',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'liburan',
        categories: [],
        src: {
          name: 'liburan.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '22ebd09f-388b-437b-8ea0-a6c28abd658e',
        templateIndex: '189',
        title: 'Liburan Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'liburan-single-page',
        categories: [],
        src: {
          name: 'liburan-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Personal'],
    src: {
      name: 'liburan.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'e923b34c-ec4d-4a3b-a1d3-b9e020e58225',
    templateIndex: '212',
    title: 'Super Nanny',
    position: 128,
    versions: [
      {
        _id: 'e923b34c-ec4d-4a3b-a1d3-b9e020e58225',
        templateIndex: '212',
        title: 'Super Nanny',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'super-nanny',
        categories: [],
        src: {
          name: 'super-nanny.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '7371b6d7-e909-4da5-8e33-c51c0168ba7b',
        templateIndex: '212',
        title: 'Super Nanny Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'super-nanny-single-page',
        categories: [],
        src: {
          name: 'supernanny-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services', 'Health'],
    src: {
      name: 'supernanny.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: '7d6ba509-80e5-4fc8-8a4b-95d1b3c1873c',
    templateIndex: '207',
    title: 'Holistic',
    position: 127,
    versions: [
      {
        _id: '5e84c440-d39f-4375-ad25-f5adf494087b',
        templateIndex: '207',
        title: 'Holistic',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'holistic',
        categories: [],
        src: {
          name: 'holistic.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '3610116b-cff7-41ac-b9ed-906fa3faa8d6',
        templateIndex: '207',
        title: 'Holistic Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'holistic-single-page',
        categories: [],
        src: {
          name: 'holistic-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    locale: ['id'],
  },
  {
    _id: 'bd949803-95c0-48ee-950f-73cb41878886',
    templateIndex: '134',
    title: 'Business Center',
    position: 126,
    versions: [
      {
        _id: 'bd949803-95c0-48ee-950f-73cb41878886',
        title: 'Business Center',
        templateIndex: '134',
        type: 'multiPages',
        link: 'business-center',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'business-center.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'b54f1a8d-b395-4c7f-a508-f3d6fa62cab0',
        versionName: 'onePage',
        title: 'Business Center Single-Page',
        templateIndex: '134',
        type: 'onePage',
        link: 'business-center-single-page',
        categories: [],
        src: {
          name: 'business-center-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'business-center.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '0d3a852b-77c6-46ca-bc30-8d526d88e8b7',
    templateIndex: '290',
    title: 'SEO Agency',
    position: 125,
    versions: [
      {
        _id: 'e9a88bef-0185-4294-8aee-d709035d3665',
        templateIndex: '290',
        title: 'SEO Agency',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'seo-agency',
        categories: [],
        src: {
          name: 'seo-agency.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '1de317df-c47c-451a-a1c1-687e6b2f60e0',
        templateIndex: '290',
        title: 'SEO Agency Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'seo-agency-single-page',
        categories: [],
        src: {
          name: 'seo-agency-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'b4879e40-559f-45fd-b25a-898d7005f16d',
    templateIndex: '195',
    title: 'Bisnis-Teknologi',
    position: 124,
    versions: [
      {
        _id: 'b4879e40-559f-45fd-b25a-898d7005f16d',
        templateIndex: '195',
        title: 'Bisnis-Teknologi',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'bisnis-teknologi',
        categories: [],
        src: {
          name: 'bisnis-teknologi.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'da6bee53-ef0c-4d5f-a78b-34c53d8b50a5',
        templateIndex: '195',
        title: 'Bisnis-Teknologi Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'bisnis-teknologi-single-page',
        categories: [],
        src: {
          name: 'bisnis-teknologi-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'bisnis-teknologi.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'c3a4d8d9-4d1a-4c72-a693-3cc83ee1b3c5',
    templateIndex: '185',
    title: 'Toy Store',
    position: 123,
    versions: [
      {
        _id: 'c3a4d8d9-4d1a-4c72-a693-3cc83ee1b3c5',
        templateIndex: '185',
        title: 'Toy Store Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'toy-store-single-page',
        categories: [],
        src: {
          name: 'toy-store-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'toy-store-single-page.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['en'],
  },
  {
    _id: '95b30705-ef17-40f8-b085-45356e45219e',
    templateIndex: '268',
    title: 'Burger Cafe',
    position: 122,
    versions: [
      {
        _id: '621d66bd-da11-441b-854f-174502a8fe52',
        templateIndex: '268',
        title: 'Burger Cafe',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'burger-cafe',
        categories: [],
        src: {
          name: 'burger-cafe.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '9f69218e-f8b4-4262-9f78-19c426882aa0',
        templateIndex: '268',
        title: 'Burger Cafe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'burger-cafe-single-page',
        categories: [],
        src: {
          name: 'burger-cafe-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: '93ba4667-9b47-4ae4-889f-35da7374c109',
    templateIndex: '209',
    title: 'Pijat van Java',
    position: 121,
    versions: [
      {
        _id: '93ba4667-9b47-4ae4-889f-35da7374c109',
        templateIndex: '209',
        title: 'Pijat van Java',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'pijat-van-java',
        categories: [],
        src: {
          name: 'pijat-van-java.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '25b39cf0-d1c2-46aa-b21a-0e8b324a1ea0',
        templateIndex: '209',
        title: 'Pijat van Java Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'pijat-van-java-single-page',
        categories: [],
        src: {
          name: 'pijat-van-java-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'pijatvanjava.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: '6f2e3727-88c8-45aa-af95-d9737767bd74',
    templateIndex: '126',
    title: 'Dentist ',
    position: 120,
    versions: [
      {
        _id: '6f2e3727-88c8-45aa-af95-d9737767bd74',
        title: 'Dentist v2',
        templateIndex: '126',
        type: 'multiPages',
        link: 'dentist-v2',
        title: 'Dentist ',
        templateIndex: '126',
        type: 'multiPages',
        link: 'dentist',
        categories: [
          '574ec22301e9d73bfb5d993c',
          '574ec22a01e9d73bfb5d993e',
          '58637d12d7bf940e2080e185',
        ],
        src: {
          name: 'dentist.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '4471531d-594a-4f04-8490-bd6183da48e5',
        versionName: 'onePage',
        title: 'Dentist v2 Single-Page',
        templateIndex: '126',
        type: 'onePage',
        link: 'dentist-v2-single-page',
        categories: [],
        src: {
          name: 'template_preview/dentistv2-singlepage.jpg',
          title: 'Dentist  Single-Page',
          templateIndex: '126',
          type: 'onePage',
          link: 'dentist-single-page',
          categories: [],
          src: {
            name: 'dentist-singlepage.jpg',
            path: '/assets/image',
          },
        },
      },
    ],
    categories: ['Services', 'Health', 'All'],
    src: {
      name: 'dentist.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '50039379-25ca-4b6c-884e-831765bad746',
    templateIndex: '180',
    title: 'Electrician',
    position: 119,
    versions: [
      {
        _id: '46207b7a-b37f-4306-b3c8-204f58d7483d',
        versionName: 'onePage',
        title: 'Electrician Single-Page',
        templateIndex: '180',
        type: 'onePage',
        link: 'electrician-single-page',
        categories: [],
        src: {
          name: 'electrician.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    src: {
      name: 'electrician.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '36faeaf5-fa34-4a10-a7d4-be492e6b9421',
    templateIndex: '206',
    title: 'Kita Peduli',
    position: 118,
    versions: [
      {
        _id: '6863fcef-21eb-40b2-b3bd-b5bc15ddf1ae',
        templateIndex: '206',
        title: 'Kita Peduli Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'kita-peduli-single-page',
        categories: [],
        src: {
          name: 'kita-peduli.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '36faeaf5-fa34-4a10-a7d4-be492e6b9421',
        templateIndex: '206',
        title: 'Kita Peduli',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'kita-peduli',
        categories: [],
        src: {
          name: 'kita-peduli.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services', 'Personal', 'Health'],
    src: {
      name: 'kitapeduli.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'e221c338-b0aa-4ae8-993e-34f810af14ce',
    templateIndex: '221',
    title: 'Yoga',
    position: 117,
    versions: [
      {
        _id: 'e221c338-b0aa-4ae8-993e-34f810af14ce',
        templateIndex: '221',
        title: 'Yoga',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'yoga',
        categories: [],
        src: {
          name: 'yoga.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'a05b3f35-b2e0-40d1-9875-f5c3d2d477c6',
        templateIndex: '221',
        title: 'Yoga Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'yoga-single-page',
        categories: [],
        src: {
          name: 'yoga-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    src: {
      name: 'yoga.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '697c23cf-72c9-45ba-99eb-6e8cabfeb2e0',
    templateIndex: '171',
    title: 'Home Decor',
    position: 116,
    versions: [
      {
        _id: '697c23cf-72c9-45ba-99eb-6e8cabfeb2e0',
        title: 'Home Decor',
        templateIndex: '171',
        type: 'multiPages',
        link: 'home-decor',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'home-decor.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '7dec1234-2edf-4b14-bc79-474b03cd7f8f',
        versionName: 'onePage',
        title: 'Home Decor Single-Page',
        templateIndex: '171',
        type: 'onePage',
        link: 'home-decor-single-page',
        categories: [],
        src: {
          name: 'home-decor.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'homedecor.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'e457f7b4-befa-4f93-82d2-0310ff1fd08f',
    templateIndex: '284',
    title: 'Accountant',
    position: 115,
    versions: [
      {
        _id: '15bf5c06-f4d7-43e3-85dc-1fa0186faea3',
        templateIndex: '284',
        title: 'Accountant',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'accountant',
        categories: [],
        src: {
          name: 'accountant.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'c71ee3d1-de67-4531-8159-ec59fe994a65',
        templateIndex: '284',
        title: 'Accountant Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'accountant-single-page',
        categories: [],
        src: {
          name: 'accountant-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '4834773e-3568-4048-8c87-323d56b07566',
    templateIndex: '201',
    title: 'Human Resources',
    position: 114,
    versions: [
      {
        _id: '4834773e-3568-4048-8c87-323d56b07566',
        templateIndex: '201',
        title: 'Human Resources',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'human-resources',
        categories: [],
        src: {
          name: 'human-resources.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '33e16b4f-121e-4bb3-b32b-c517ccf8e814',
        templateIndex: '201',
        title: 'Human Resources Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'human-resources-single-page',
        categories: [],
        src: {
          name: 'human-resources.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'human-resources.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'ed9afbae-5db4-4ed6-8f53-cfb2e7abe932',
    templateIndex: '188',
    title: 'Cafe',
    position: 113,
    versions: [
      {
        _id: 'ed9afbae-5db4-4ed6-8f53-cfb2e7abe932',
        templateIndex: '188',
        title: 'Cafe',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'cafe-id',
        categories: [],
        src: {
          name: 'cafe-id.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f89ce2f8-cc88-4cf7-b72f-92b288b65037',
        templateIndex: '188',
        title: 'Cafe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'cafe-id-single-page',
        categories: [],
        src: {
          name: 'cafe-id-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    src: {
      name: 'cafe-id.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: '1fb511ea-aad6-41fc-8962-12ac2f0925e0',
    templateIndex: '193',
    title: 'Batik',
    position: 112,
    versions: [
      {
        _id: '1fb511ea-aad6-41fc-8962-12ac2f0925e0',
        templateIndex: '193',
        title: 'Batik',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'batik',
        categories: [],
        src: {
          name: 'batik.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f047335d-13f8-4d37-80a2-380511533ab4',
        templateIndex: '193',
        title: 'Batik Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'batik-single-page',
        categories: [],
        src: {
          name: 'batik-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'batik.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'c819c3f7-f512-4eb5-aa06-0f10fc27e78b',
    templateIndex: '194',
    title: 'Foundation',
    position: 111,
    versions: [
      {
        _id: 'c819c3f7-f512-4eb5-aa06-0f10fc27e78b',
        templateIndex: '194',
        title: 'Foundation',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'foundation',
        categories: [],
        src: {
          name: 'foundation.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '36678e07-43ac-484c-9112-3c185aad13b2',
        templateIndex: '194',
        title: 'Foundation Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'foundation-single-page',
        categories: [],
        src: {
          name: 'foundation-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Personal'],
    src: {
      name: 'foundation.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['id'],
  },
  {
    _id: 'c2b0d4ca-2e77-4570-8dc4-51860cd42d19',
    templateIndex: '288',
    title: 'Pizza Restaurant',
    position: 110,
    versions: [
      {
        _id: '93d82e47-c5cb-46fc-ae46-bd8b743702f7',
        templateIndex: '288',
        title: 'Pizza Restaurant',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'pizza-restaurant',
        categories: [],
        src: {
          name: 'pizza-restaurant.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8f79cbeb-b23b-457a-95ba-04009015045b',
        templateIndex: '288',
        title: 'Pizza Restaurant Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'pizza-restaurant-single-page',
        categories: [],
        src: {
          name: 'pizza-restaurant-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: 'b058db1e-86aa-418d-9889-4b100b85f530',
    templateIndex: '186',
    title: 'Auto Repairs',
    position: 109,
    versions: [
      {
        _id: 'b058db1e-86aa-418d-9889-4b100b85f530',
        templateIndex: '186',
        title: 'Auto Repairs',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'auto-repairs',
        categories: [],
        src: {
          name: 'auto-repairs.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b2f5fbc2-ee92-4f10-a3b1-dbe611f2f1be',
        templateIndex: '186',
        title: 'Auto Repairs Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'auto-repairs-single-page',
        categories: [],
        src: {
          name: 'auto-repairs.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'auto-repairs.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'd1ac4432-dc58-4499-8bf5-55a776b901dd',
    templateIndex: '210',
    title: 'City Hotel',
    position: 108,
    versions: [
      {
        _id: 'd1ac4432-dc58-4499-8bf5-55a776b901dd',
        templateIndex: '210',
        title: 'City Hotel',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'city-hotel',
        categories: [],
        src: {
          name: 'city-hotel.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b41a9cfb-5389-4d1d-92cd-e8fa6bac839f',
        templateIndex: '210',
        title: 'City Hotel Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'city-hotel-single-page',
        categories: [],
        src: {
          name: 'city-hotel.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'city-hotel.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '40ae6e0b-79a5-40e3-8170-f3c5dfb5c0b6',
    templateIndex: '198',
    title: 'Window Cleaners',
    position: 107,
    versions: [
      {
        _id: '40ae6e0b-79a5-40e3-8170-f3c5dfb5c0b6',
        templateIndex: '198',
        title: 'Window Cleaners',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'window-cleaners',
        categories: [],
        src: {
          name: 'window-cleaners.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '684a07e3-97e6-4b85-bebf-18fd0e578c53',
        templateIndex: '198',
        title: 'Window Cleaners Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'window-cleaners-single-page',
        categories: [],
        src: {
          name: 'window-cleaners.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    src: {
      name: 'window-cleaners.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'd4e0a117-7f42-4686-b652-84c37b27f429',
    templateIndex: '276',
    title: 'Coffee House',
    position: 106,
    versions: [
      {
        _id: 'e934475b-aa80-45d1-a6df-a0fc62d5540c',
        templateIndex: '276',
        title: 'Coffee House',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'coffee-house',
        categories: [],
        src: {
          name: 'coffee-house.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e4a11dd7-2389-4578-83bf-b9319bcb9584',
        templateIndex: '276',
        title: 'Coffee House Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'coffee-house-single-page',
        categories: [],
        src: {
          name: 'coffee-house-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: '970bdd03-dc76-41c2-9b95-486518f00da8',
    templateIndex: '274',
    title: 'Plasterer',
    position: 105,
    versions: [
      {
        _id: 'd0fae258-b9ab-477c-ba38-877b811227c4',
        templateIndex: '274',
        title: 'Plasterer',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'plasterer',
        categories: [],
        src: {
          name: 'plasterer.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '0922b74d-41b5-448f-80c7-28887b23fe7f',
        templateIndex: '274',
        title: 'Plasterer Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'plasterer-single-page',
        categories: [],
        src: {
          name: 'plasterer-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '3a6e3be0-478e-4404-b039-8f5bcaf8a196',
    templateIndex: '278',
    title: 'Fitness Gym',
    position: 104,
    versions: [
      {
        _id: 'b84c7ebb-d5c5-48ca-8d54-8504fa413620',
        templateIndex: '278',
        title: 'Fitness Gym',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fitness-gym',
        categories: [],
        src: {
          name: 'fitness-gym.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '356dfbc9-f260-4ac1-99ac-61fa499eb1eb',
        templateIndex: '278',
        title: 'Fitness Gym Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fitness-gym-single-page',
        categories: [],
        src: {
          name: 'fitness-gym-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    locale: ['en'],
  },
  {
    _id: '3d889832-48fd-4b74-af5b-c54918e77210',
    templateIndex: '277',
    title: 'Solar Panels',
    position: 103,
    versions: [
      {
        _id: 'be22f1d2-43b2-43b1-8b3a-bb78f12991b9',
        templateIndex: '277',
        title: 'Solar Panels',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'solar-panels',
        categories: [],
        src: {
          name: 'solar-panels.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '20ffe434-1d53-4c5b-bdfc-3d49bc4674b5',
        templateIndex: '277',
        title: 'Solar Panels Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'solar-panels-single-page',
        categories: [],
        src: {
          name: 'solar-panels-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '25cf8059-3946-491c-adbc-c60fc39fccf3',
    templateIndex: '187',
    title: 'Body Guard',
    position: 102,
    versions: [
      {
        _id: '25cf8059-3946-491c-adbc-c60fc39fccf3',
        templateIndex: '187',
        title: 'Body Guard',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'body-guard',
        categories: [],
        src: {
          name: 'body-guard.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '6bfc790c-4b2d-4987-b8de-002a2a6ccc99',
        templateIndex: '187',
        title: 'Body Guard Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'body-guard-single-page',
        categories: [],
        src: {
          name: 'body-guard.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'body-guard.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '7b98df13-bf4e-45e1-9c6c-6f9dd4010d84',
    templateIndex: '243',
    title: 'Training Courses',
    position: 101,
    versions: [
      {
        _id: 'b37801e5-8f18-4e04-8a3f-d601eb1fdc61',
        templateIndex: '243',
        title: 'Training Courses',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'training-courses',
        categories: [],
        src: {
          name: 'training-courses.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '0ee99b42-af11-4096-98ab-d4f4846b4198',
        templateIndex: '243',
        title: 'Training Courses Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'training-courses-single-page',
        categories: [],
        src: {
          name: 'training-courses-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'e34573a3-782e-4fc3-b215-1992a1299259',
    templateIndex: '252',
    title: 'Catering Services',
    position: 100,
    versions: [
      {
        _id: '8f6cb5ca-179c-4f8b-9e54-823e2df17b9c',
        templateIndex: '252',
        title: 'Catering Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'catering-services',
        categories: [],
        src: {
          name: 'catering-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '302553b7-9edb-42a6-914b-e48f8abeac27',
        templateIndex: '252',
        title: 'Catering Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'catering-services-single-page',
        categories: [],
        src: {
          name: 'catering-services.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: 'ffc1dfff-7dbd-4c4b-966a-435e8b0a519a',
    templateIndex: '294',
    title: 'Veterinary Clinic',
    position: 99,
    versions: [
      {
        _id: 'd103b1e0-1555-4280-a4fe-d48cd3c6fb34',
        templateIndex: '294',
        title: 'Veterinary Clinic',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'veterinary-clinic',
        categories: [],
        src: {
          name: 'veterinary-clinic.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'ce132db9-4264-4ee3-8baf-29cb4f08afda',
        templateIndex: '294',
        title: 'Veterinary Clinic Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'veterinary-clinic-single-page',
        categories: [],
        src: {
          name: 'veterinary-clinic.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'fb2f32af-405b-4353-b2b0-da492c6a1853',
    templateIndex: '177',
    title: 'Moving Company',
    position: 98,
    versions: [
      {
        _id: 'fb2f32af-405b-4353-b2b0-da492c6a1853',
        title: 'Moving Company',
        templateIndex: '177',
        type: 'multiPages',
        link: 'moving-company',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'moving-company.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '19158be4-cf79-457f-89c8-cbf5d9f18c56',
        versionName: 'onePage',
        title: 'Moving Company Single-Page',
        templateIndex: '177',
        type: 'onePage',
        link: 'moving-company-single-page',
        categories: [],
        src: {
          name: 'moving-company.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'movingcompany.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'a04d54ca-8703-4574-bafc-456438782cdb',
    templateIndex: '256',
    title: 'Landscape Design',
    position: 97,
    versions: [
      {
        _id: 'ddf35b1f-038a-4764-888d-bcb9d63712a4',
        templateIndex: '256',
        title: 'Landscape Design',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'landscape-design',
        categories: [],
        src: {
          name: 'landscape-design.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '77331abd-cad2-4bda-a9fa-d29cec306146',
        templateIndex: '256',
        title: 'Landscape Design Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'landscape-design-single-page',
        categories: [],
        src: {
          name: 'landscape-design.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'bd20c1eb-4bd1-4e09-99ca-93873826495d',
    templateIndex: '255',
    title: 'Career Services',
    position: 96,
    versions: [
      {
        _id: '7fd78825-17c4-4e0f-a6bc-9f3e2e36e8ce',
        templateIndex: '255',
        title: 'Career Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'career-services',
        categories: [],
        src: {
          name: 'career-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '63a3bc0e-d7db-4f85-9d40-696b896618fa',
        templateIndex: '255',
        title: 'Career Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'career-services-single-page',
        categories: [],
        src: {
          name: 'career-services.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '36d556c3-ac5d-4f47-b671-6ba3a6fd566d',
    templateIndex: '272',
    title: 'Wedding Event',
    position: 95,
    versions: [
      {
        _id: '430c7399-eded-427e-ac9b-82adef6ffb64',
        templateIndex: '272',
        title: 'Wedding Event',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'wedding-event',
        categories: [],
        src: {
          name: 'wedding-event.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '1015f52f-20db-4eae-a926-879de7978f07',
        templateIndex: '272',
        title: 'Wedding Event Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'wedding-event-single-page',
        categories: [],
        src: {
          name: 'wedding-event-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Personal'],
    locale: ['en'],
  },
  {
    _id: '5bc18713-d341-44fa-bf7f-6d99e96da140',
    templateIndex: '253',
    title: 'Cleaning Services',
    position: 94,
    versions: [
      {
        _id: '8d77c5c8-e66b-45b4-9e35-e9af40217e01',
        templateIndex: '253',
        title: 'Cleaning Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'cleaning-services',
        categories: [],
        src: {
          name: 'cleaning-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '79a60410-2598-422b-80e9-9f4e207e3952',
        templateIndex: '253',
        title: 'Cleaning Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'cleaning-services-single-page',
        categories: [],
        src: {
          name: 'cleaning-services.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'ab8a2465-d128-4aae-9d2b-0984dd123339',
    templateIndex: '175',
    title: 'Manicure Services',
    position: 93,
    versions: [
      {
        _id: 'ab8a2465-d128-4aae-9d2b-0984dd123339',
        title: 'Manicure Services',
        templateIndex: '175',
        type: 'multiPages',
        link: 'manicure-services',
        categories: ['58637d12d7bf940e2080e185', '574ec20a01e9d73bfb5d993a'],
        src: {
          name: 'manicure-services.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'b1f0b607-31dd-4596-a997-ece9d605011c',
        versionName: 'onePage',
        title: 'Manicure Services Single-Page',
        templateIndex: '175',
        type: 'onePage',
        link: 'manicure-services-single-page',
        categories: [],
        src: {
          name: 'manicure-services.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    src: {
      name: 'manicure-services.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'f084a103-8af3-425c-82c1-282916f39c51',
    templateIndex: '293',
    title: 'Pest Control',
    position: 92,
    versions: [
      {
        _id: '403c7645-0e7b-46d8-ad65-7125a7442bc2',
        templateIndex: '293',
        title: 'Pest Control',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'pest-control',
        categories: [],
        src: {
          name: 'pest-control.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f7c9e34c-b8c6-497b-b529-b2d7cfecf6a6',
        templateIndex: '293',
        title: 'Pest Control Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'pest-control-single-page',
        categories: [],
        src: {
          name: 'pest-control-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'b4f45548-d5c5-4f80-a933-9ab0584811a9',
    templateIndex: '283',
    title: 'Water Delivery',
    position: 91,
    versions: [
      {
        _id: '3ee5acad-1db4-4d3d-9cb0-27aadb9705b8',
        templateIndex: '283',
        title: 'Water Delivery',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'water-delivery',
        categories: [],
        src: {
          name: 'water-delivery.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'cd9a4365-946f-4c6e-8aa6-364e9bfa6433',
        templateIndex: '283',
        title: 'Water Delivery Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'water-delivery-single-page',
        categories: [],
        src: {
          name: 'water-delivery-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '0a72366f-9f9e-4d14-8654-689979c66f66',
    templateIndex: '269',
    title: 'Welder',
    position: 90,
    versions: [
      {
        _id: 'aba9fab9-9e50-455b-8b0b-f76d40632f8f',
        templateIndex: '269',
        title: 'Welder',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'welder',
        categories: [],
        src: {
          name: 'welder.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '64ff1685-7731-4e54-9a91-59c4222d1203',
        templateIndex: '269',
        title: 'Welder Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'welder-single-page',
        categories: [],
        src: {
          name: 'welder-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '6ce96fc0-2e73-4f7a-b563-b3287386f630',
    templateIndex: '234',
    title: 'Wedding Planner',
    position: 89,
    versions: [
      {
        _id: '5e38c3e6-e220-4baa-bce5-6067a1b85afa',
        templateIndex: '234',
        title: 'Wedding Planner',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'wedding-planner',
        categories: [],
        src: {
          name: 'wedding-planner.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '2c1ec95d-3b73-4896-911c-eb9a10f87e06',
        templateIndex: '234',
        title: 'Wedding Planner Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'wedding-planner-single-page',
        categories: [],
        src: {
          name: 'wedding-planner-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'af515395-945e-41f2-a9ad-4e5360c4a970',
    templateIndex: '292',
    title: 'Conference',
    position: 88,
    versions: [
      {
        _id: '5a3ac0da-1c5e-46c1-a86c-281a499df61a',
        templateIndex: '292',
        title: 'Conference',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'conference',
        categories: [],
        src: {
          name: 'conference.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '1f482c10-c6c7-4232-86a6-9621840a80e7',
        templateIndex: '292',
        title: 'Conference Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'conference-single-page',
        categories: [],
        src: {
          name: 'conference-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Personal'],
    locale: ['en'],
  },
  {
    _id: '70ce959d-e05a-4605-8755-b620c8753506',
    templateIndex: '174',
    title: 'Barber Shop',
    position: 87,
    versions: [
      {
        _id: '70ce959d-e05a-4605-8755-b620c8753506',
        title: 'Barber Shop',
        templateIndex: '174',
        type: 'multiPages',
        link: 'barber-shop',
        categories: ['58637d12d7bf940e2080e185', '574ec20a01e9d73bfb5d993a'],
        src: {
          name: 'barber-shop.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '66833816-6637-43b5-b865-7fa41f04bea7',
        versionName: 'onePage',
        title: 'Barber Shop Single-Page',
        templateIndex: '174',
        type: 'onePage',
        link: 'barber-shop-single-page',
        categories: [],
        src: {
          name: 'barber-shop.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    src: {
      name: 'barber-shop.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'dc218103-5bf1-4a1d-88aa-453f668b338d',
    templateIndex: '271',
    title: 'SPA',
    position: 86,
    versions: [
      {
        _id: '94abac5d-fb7f-470f-a571-1d2e10e33d87',
        templateIndex: '271',
        title: 'SPA',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'spa',
        categories: [],
        src: {
          name: 'spa.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8c0efe40-176c-4732-a330-f064c6e45fc7',
        templateIndex: '271',
        title: 'SPA Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'spa-single-page',
        categories: [],
        src: {
          name: 'spa-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    locale: ['en'],
  },
  {
    _id: 'edd34b18-1211-47ca-a553-bb96f7c95611',
    templateIndex: '260',
    title: 'Villa Rental',
    position: 85,
    versions: [
      {
        _id: '51760505-0a90-46de-a0ee-bc65a58ad8bd',
        templateIndex: '260',
        title: 'Villa Rental',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'villa-rental',
        categories: [],
        src: {
          name: 'villa-rental.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '975cb0a6-27db-49ae-959c-871249a318f5',
        templateIndex: '260',
        title: 'Villa Rental Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'villa-rental-single-page',
        categories: [],
        src: {
          name: 'villa-rental.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '2b2ac2ef-021f-41b3-90fd-b6b6ebe77ba5',
    templateIndex: '240',
    title: 'Car Dealer',
    position: 84,
    versions: [
      {
        _id: '4ee3607a-9176-4fd9-b746-a0ecabc575ef',
        templateIndex: '240',
        title: 'Car Dealer',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'car-dealer',
        categories: [],
        src: {
          name: 'car-dealer.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8f61cc21-3993-44e5-887d-fc40f448c043',
        templateIndex: '240',
        title: 'Car Dealer Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'car-dealer-single-page',
        categories: [],
        src: {
          name: 'car-dealer-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '808a4b05-0af6-467a-ab17-ac218bbdb89b',
    templateIndex: '250',
    title: 'Soccer Club',
    position: 83,
    versions: [
      {
        _id: 'e618c235-4849-4303-b53f-c970c7e3df30',
        templateIndex: '250',
        title: 'Soccer Club',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'soccer-club',
        categories: [],
        src: {
          name: 'soccer-club.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '79eddff0-76bc-41ca-be4d-acc6dc82fe76',
        templateIndex: '250',
        title: 'Soccer Club Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'soccer-club-single-page',
        categories: [],
        src: {
          name: 'soccer-club.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '463e4379-4c72-4811-9d99-99a5de29d909',
    templateIndex: '245',
    title: 'Financial Planners',
    position: 82,
    versions: [
      {
        _id: '597d1dc1-3bf5-4d83-b649-52f57365ce0c',
        templateIndex: '245',
        title: 'Financial Planners',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'financial-planners',
        categories: [],
        src: {
          name: 'financial-planners.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b8b7f738-0a3f-431b-9d36-2f80203c825e',
        templateIndex: '245',
        title: 'Financial Planners Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'financial-planners-single-page',
        categories: [],
        src: {
          name: 'financial-planners-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'acc3c479-3d2d-4c67-a3a9-41628f8c8de7',
    templateIndex: '249',
    title: 'Law Firm',
    position: 81,
    versions: [
      {
        _id: '33889710-80db-47d7-a6ea-51a61f78c8dc',
        templateIndex: '249',
        title: 'Law Firm',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'law-firm',
        categories: [],
        src: {
          name: 'law-firm.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'ddf45e33-b0d0-4637-82b7-c5ca48355d6e',
        templateIndex: '249',
        title: 'Law Firm Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'law-firm-single-page',
        categories: [],
        src: {
          name: 'law-firm-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '4951a59d-f78b-4c50-bbfc-cebb2b9d9ec2',
    templateIndex: '264',
    title: 'Roof Carpenters',
    position: 80,
    versions: [
      {
        _id: '77d1089f-a295-41c5-9bff-53daa189a92b',
        templateIndex: '264',
        title: 'Roof Carpenters',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'roof-carpenters',
        categories: [],
        src: {
          name: 'roof-carpenters.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b4bf4b88-d0d5-4c5e-aa9e-98c421f69f7c',
        templateIndex: '264',
        title: 'Roof Carpenters Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'roof-carpenters-single-page',
        categories: [],
        src: {
          name: 'roof-carpenters.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '46c8672b-6e0e-4cae-ace7-5361c7a2099b',
    templateIndex: '273',
    title: 'Party Planning',
    position: 79,
    versions: [
      {
        _id: '423e885f-02d3-4a09-b04c-afe879bbf166',
        templateIndex: '273',
        title: 'Party Planning',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'party-planning',
        categories: [],
        src: {
          name: 'party-planning.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '37abd030-0f7f-4671-86fd-8e9c1159b5e4',
        templateIndex: '273',
        title: 'Party Planning Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'party-planning-single-page',
        categories: [],
        src: {
          name: 'party-planning.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '6b470fa4-22ed-4966-8ca4-04d5245f998a',
    templateIndex: '291',
    title: 'Mortgage Brokers',
    position: 78,
    versions: [
      {
        _id: '83482f16-d4ee-4344-bc36-55cf91ab8607',
        templateIndex: '291',
        title: 'Mortgage Brokers',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'mortgage-brokers',
        categories: [],
        src: {
          name: 'mortgage-brokers.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '20abc451-0e41-4c1b-898b-383332851968',
        templateIndex: '291',
        title: 'Mortgage Brokers Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'mortgage-brokers-single-page',
        categories: [],
        src: {
          name: 'mortgage-brokers-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '7a9ba5b5-a124-49cd-9617-b859a8d2337c',
    templateIndex: '258',
    title: 'Real Estate',
    position: 77,
    versions: [
      {
        _id: 'ac7f6f56-2251-4c9b-9dee-5d652ae9cff4',
        templateIndex: '258',
        title: 'Real Estate',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'real-estate',
        categories: [],
        src: {
          name: 'real-estate.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '5680ddec-907b-4d1b-b531-0f2a25dd68f6',
        templateIndex: '258',
        title: 'Real Estate Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'real-estate-single-page',
        categories: [],
        src: {
          name: 'real-estate.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  // {
  //   "_id": "bc32a5ed-ca59-404c-9b54-35d870ca7b96",
  //   "templateIndex": "182",
  //   "title": "Bookstore",
  //   "position": 76,
  //   "versions": [
  //     {
  //       "_id": "bc32a5ed-ca59-404c-9b54-35d870ca7b96",
  //       "templateIndex": "182",
  //       "title": "Bookstore Single-Page",
  //       "versionName": "onePage",
  //       "type": "onePage",
  //       "link": "bookstore-single-page",
  //       "categories": [],
  //       "src": {
  //         "name": "bookstore2-singlepage.jpg",
  //         "path": "/assets/image"
  //       }
  //     }
  //   ],
  //   "categories": [
  //     "All",
  //     "Business"
  //   ],
  //   "src": {
  //     "name": "bookstore2-singlepage.jpg",
  //     "path": "/assets/image"
  //   },
  //   "type": "onePage",
  //   "versionName": "onePage",
  //   "locale": [
  //     "en"
  //   ]
  // },
  {
    _id: 'fa09cc89-63ea-4a77-bd0f-eb9368f26224',
    templateIndex: '244',
    title: 'Childcare',
    position: 75,
    versions: [
      {
        _id: '2f3ede1d-6d34-47c3-a596-15888c1967be',
        templateIndex: '244',
        title: 'Childcare',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'childcare',
        categories: [],
        src: {
          name: 'childcare.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '368ed735-adee-41ab-8738-f64da791f325',
        templateIndex: '244',
        title: 'Childcare Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'childcare-single-page',
        categories: [],
        src: {
          name: 'childcare-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '98953690-ff5e-49a9-8dca-b7f2888eaf4a',
    templateIndex: '154',
    title: 'Bricklayer',
    position: 74,
    versions: [
      {
        _id: '98953690-ff5e-49a9-8dca-b7f2888eaf4a',
        title: 'Bricklayer',
        templateIndex: '154',
        type: 'multiPages',
        link: 'bricklayer',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'bricklayer.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '923f4640-e257-43eb-8c94-374c36251b1a',
        versionName: 'onePage',
        title: 'Bricklayer Single-Page',
        templateIndex: '154',
        type: 'onePage',
        link: 'bricklayer-single-page',
        categories: [],
        src: {
          name: 'bricklayer-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'bricklayer.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '6d7755cb-d288-47ea-92ab-5cf748f9b2b3',
    templateIndex: '270',
    title: 'Crossfit',
    position: 73,
    versions: [
      {
        _id: '799343ac-1e2b-433b-bd77-be6d369033fb',
        templateIndex: '270',
        title: 'Crossfit',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'crossfit',
        categories: [],
        src: {
          name: 'crossfit.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '1848442d-12a8-4a37-81e0-d7a2b01c2993',
        templateIndex: '270',
        title: 'Crossfit Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'crossfit-single-page',
        categories: [],
        src: {
          name: 'crossfit-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    locale: ['en'],
  },
  {
    _id: '278e4f1a-9a0a-4383-8414-48c4d53c973b',
    templateIndex: '281',
    title: 'Locksmith',
    position: 72,
    versions: [
      {
        _id: 'eb21b6cc-4a40-4983-b7f8-caf7987b8509',
        templateIndex: '281',
        title: 'Locksmith',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'locksmith',
        categories: [],
        src: {
          name: 'locksmith.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '91e9ad62-63ff-4cd1-9778-dba0ae412064',
        templateIndex: '281',
        title: 'Locksmith Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'locksmith-single-page',
        categories: [],
        src: {
          name: 'locksmith-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'ff00957d-6c8d-4e82-8283-4489227c5746',
    templateIndex: '257',
    title: 'Fashion Store',
    position: 71,
    versions: [
      {
        _id: 'f64ed54a-c073-400a-9547-7b8f822ad29f',
        templateIndex: '257',
        title: 'Fashion Store',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fashion-store',
        categories: [],
        src: {
          name: 'fashion-store.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'dfa994dc-8434-43d0-a39c-2048808e8d6a',
        templateIndex: '257',
        title: 'Fashion Store Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fashion-store-single-page',
        categories: [],
        src: {
          name: 'fashion-store-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '09ecc437-0f57-4d12-8237-287f43685c21',
    templateIndex: '285',
    title: 'Medical Clinic',
    position: 70,
    versions: [
      {
        _id: 'c2d18296-98c9-4e0c-b5ce-7fd286fe776c',
        templateIndex: '285',
        title: 'Medical Clinic',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'medical-clinic',
        categories: [],
        src: {
          name: 'medical-clinic.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '2d1d8197-5ee6-4ef7-9471-8a29aa320bce',
        templateIndex: '285',
        title: 'Medical Clinic Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'medical-clinic-single-page',
        categories: [],
        src: {
          name: 'medical-clinic-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '6444ae4e-8a6e-46c7-a614-7b9decd161e7',
    templateIndex: '239',
    title: 'Architect',
    position: 69,
    versions: [
      {
        _id: 'b000a605-d6d4-44dc-8017-77948bcfea16',
        templateIndex: '239',
        title: 'Architect',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'architect',
        categories: [],
        src: {
          name: 'architect.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e7c3cc21-cabe-4d17-8d7f-fa1403376d60',
        templateIndex: '239',
        title: 'Architect Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'architect-single-page',
        categories: [],
        src: {
          name: 'architect-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'b79c3879-3bbc-475d-a2b1-2da1b9759cfb',
    templateIndex: '251',
    title: 'Fresh Produce',
    position: 68,
    versions: [
      {
        _id: '13e3e7c1-142b-4ae6-9011-89da78daf059',
        templateIndex: '251',
        title: 'Fresh Produce',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'fresh-produce',
        categories: [],
        src: {
          name: 'fresh-produce.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'cdd979a4-3c84-42c7-bba8-1fdbf8fb1a50',
        templateIndex: '251',
        title: 'Fresh Produce Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'fresh-produce-single-page',
        categories: [],
        src: {
          name: 'fresh-produce.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '1f895975-ff24-4ee9-a12c-7d572cba403a',
    templateIndex: '261',
    title: 'Limo Services',
    position: 67,
    versions: [
      {
        _id: '75556478-6acb-4f8b-8a44-7bb52c69fa0a',
        templateIndex: '261',
        title: 'Limo Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'limo-services',
        categories: [],
        src: {
          name: 'limo-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '85289ddc-b7ff-4b87-89de-8c74b1e67cd2',
        templateIndex: '261',
        title: 'Limo Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'limo-services-single-page',
        categories: [],
        src: {
          name: 'limo-services-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'a0948338-72be-484c-985f-dca5b301edb7',
    templateIndex: '169',
    title: 'Brick Paver',
    position: 66,
    versions: [
      {
        _id: 'a0948338-72be-484c-985f-dca5b301edb7',
        title: 'Brick Paver',
        templateIndex: '169',
        type: 'multiPages',
        link: 'brick-paver',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'brick-paver.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'a40c8049-696b-4d6e-94a7-c1d6368578f4',
        versionName: 'onePage',
        title: 'Brick Paver Single-Page',
        templateIndex: '169',
        type: 'onePage',
        link: 'brick-paver-single-page',
        categories: [],
        src: {
          name: 'brick-paver-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'brick-paver.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: 'e4bf7772-4e1b-422c-8bbb-73e28c72360d',
    templateIndex: '263',
    title: 'Security Services',
    position: 65,
    versions: [
      {
        _id: '53b57c74-d05b-4c17-9835-6381f280902b',
        templateIndex: '263',
        title: 'Security Services',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'security-services',
        categories: [],
        src: {
          name: 'security-services.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '346925fc-76e3-49bd-9ff9-6f06bd9f588c',
        templateIndex: '263',
        title: 'Security Services Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'security-services-single-page',
        categories: [],
        src: {
          name: 'security-services-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '8c2b6288-9b6b-497d-acea-6ec976133418',
    templateIndex: '178',
    title: 'Animal Groomers',
    position: 64,
    versions: [
      {
        _id: '8c2b6288-9b6b-497d-acea-6ec976133418',
        title: 'Animal Groomers',
        templateIndex: '178',
        type: 'multiPages',
        link: 'animal-groomers',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'animal-groomers.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '8b7b9509-ce26-41d5-8707-8f6c1e874d2d',
        versionName: 'onePage',
        title: 'Animal Groomers Single-Page',
        templateIndex: '178',
        type: 'onePage',
        link: 'animal-groomers-single-page',
        categories: [],
        src: {
          name: 'animal-groomers.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'animal-groomers.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '9a3cbe63-9c16-44e7-81ff-44987b40df9d',
    templateIndex: '280',
    title: 'Tour Guide',
    position: 63,
    versions: [
      {
        _id: 'a4e23338-af92-4dc3-8646-c398ab734991',
        templateIndex: '280',
        title: 'Tour Guide',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'tour-guide',
        categories: [],
        src: {
          name: 'tour-guide.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'fd82cb95-74d0-48af-b7d4-552f52dc8472',
        templateIndex: '280',
        title: 'Tour Guide Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'tour-guide-single-page',
        categories: [],
        src: {
          name: 'tour-guide-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Business'],
    locale: ['en'],
  },
  {
    _id: '5fb145af-096a-42b1-acec-7d7976417c86',
    templateIndex: '232',
    title: 'Plumber',
    position: 62,
    versions: [
      {
        _id: '13411e09-809b-4bfb-96b6-a63a3ed9d34b',
        templateIndex: '232',
        title: 'Plumber',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'plumber',
        categories: [],
        src: {
          name: 'plumber.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'd9f691a6-aa2a-4d38-baee-480a461684a6',
        templateIndex: '232',
        title: 'Plumber Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'plumber-single-page',
        categories: [],
        src: {
          name: 'plumber-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '8029cdee-71a0-4ff1-b70a-42215d520f9a',
    templateIndex: '233',
    title: 'Painters',
    position: 61,
    versions: [
      {
        _id: '323b6c5b-c2d5-4c01-943f-27d60c192c7a',
        templateIndex: '233',
        title: 'Painters',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'painters',
        categories: [],
        src: {
          name: 'painters.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '4d6757c6-d6aa-416e-86d1-c579953420da',
        templateIndex: '233',
        title: 'Painters Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'painters-single-page',
        categories: [],
        src: {
          name: 'painters-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '1cc6b6c4-d6c6-4b1c-825b-7a86ff24e5e6',
    templateIndex: '236',
    title: 'DJ',
    position: 60,
    versions: [
      {
        _id: '2ecec0be-57e8-4ee8-a609-6eee80257377',
        templateIndex: '236',
        title: 'DJ',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'dj',
        categories: [],
        src: {
          name: 'dj.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '95210ad3-7897-4f07-8280-e8488b7563bf',
        templateIndex: '236',
        title: 'DJ Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'dj-single-page',
        categories: [],
        src: {
          name: 'dj-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '2497c531-7a5c-4a30-9eb7-cf56cc0b1572',
    templateIndex: '235',
    title: 'Gardener',
    position: 59,
    versions: [
      {
        _id: 'c32fee43-aa31-4aa8-9b3a-8a5e9464967b',
        templateIndex: '235',
        title: 'Gardener',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'gardener',
        categories: [],
        src: {
          name: 'gardener.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '931c4e55-87fe-499f-95eb-6fb0d2f37ee0',
        templateIndex: '235',
        title: 'Gardener Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'gardener-single-page',
        categories: [],
        src: {
          name: 'gardener-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '76085c55-3bb6-47d1-afca-7cb4d225543b',
    templateIndex: '142',
    title: 'Tiler',
    position: 58,
    versions: [
      {
        _id: '76085c55-3bb6-47d1-afca-7cb4d225543b',
        title: 'Tiler',
        templateIndex: '142',
        type: 'multiPages',
        link: 'tiler',
        categories: [
          '58637d12d7bf940e2080e185',
          '574ec0f301e9d73bfb5d9937',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'tiler.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'de9b697e-1953-452f-8cd2-419238f32918',
        versionName: 'onePage',
        title: 'Tiler Single-Page',
        templateIndex: '142',
        type: 'onePage',
        link: 'tiler-single-page',
        categories: [],
        src: {
          name: 'tiler-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Services'],
    src: {
      name: 'tiler.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '8851e624-a831-4f7b-9677-4a6a1f8d39c6',
    templateIndex: '279',
    title: 'Local Cafe',
    position: 56,
    versions: [
      {
        _id: '956afa98-cc54-4f62-a78f-4aaa2586396f',
        templateIndex: '279',
        title: 'Local Cafe',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'local-cafe',
        categories: [],
        src: {
          name: 'local-cafe.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'b36609a0-e459-4676-aafc-4cc6e196ac67',
        templateIndex: '279',
        title: 'Local Cafe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'local-cafe-single-page',
        categories: [],
        src: {
          name: 'local-cafe-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: '7cfb6a7e-ce4b-4497-9160-7f619be67692',
    templateIndex: '231',
    title: 'Event Venue',
    position: 55,
    versions: [
      {
        _id: '1986c437-f6cf-4b00-92a7-be22b9962a06',
        templateIndex: '231',
        title: 'Event Venue',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'event-venue',
        categories: [],
        src: {
          name: 'event-venue.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '203e4791-ed23-4681-9dc7-e9bf6c391ae3',
        templateIndex: '231',
        title: 'Event Venue Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'event-venue-single-page',
        categories: [],
        src: {
          name: 'event-venue-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: 'a96b460a-e6cf-42cb-b05d-dd9c192b235a',
    templateIndex: '266',
    title: 'Seafood Restaurant',
    position: 54,
    versions: [
      {
        _id: 'cb0ed989-4299-4906-a679-23ad35346ab0',
        templateIndex: '266',
        title: 'Seafood Restaurant',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'seafood-restaurant',
        categories: [],
        src: {
          name: 'seafood-restaurant.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'ad6be700-70cc-4425-9421-81a2c8e6295d',
        templateIndex: '266',
        title: 'Seafood Restaurant Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'seafood-restaurant-single-page',
        categories: [],
        src: {
          name: 'seafood-restaurant-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Restaurant'],
    locale: ['en'],
  },
  {
    _id: 'b62e482c-3f15-488c-913a-80a458ce76eb',
    templateIndex: '262',
    title: 'Biography',
    position: 53,
    versions: [
      {
        _id: 'c475251e-565b-4ac4-a3a6-10a810bff7e1',
        templateIndex: '262',
        title: 'Biography',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'biography',
        categories: [],
        src: {
          name: 'biography.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f9820b60-a727-431d-b804-da4be4191f39',
        templateIndex: '262',
        title: 'Biography Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'biography-single-page',
        categories: [],
        src: {
          name: 'biography-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    locale: ['en'],
  },
  {
    _id: 'ccfbe986-2594-4c7a-9ffe-588f13b063ba',
    templateIndex: '192',
    title: 'Olah Raga',
    position: 52,
    versions: [
      {
        _id: 'ccfbe986-2594-4c7a-9ffe-588f13b063ba',
        templateIndex: '192',
        title: 'Olah Raga Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'olah-raga-single-page',
        categories: [],
        src: {
          name: 'olah-raga.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'f98a4397-6823-4fd0-8c1f-f38d9d1cdaf0',
        templateIndex: '192',
        title: 'Olah Raga',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'olah-raga',
        categories: [],
        src: {
          name: 'olah-raga.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    src: {
      name: 'olahraga-singlepage.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['id'],
  },
  {
    _id: '11ada636-65c3-49ee-800f-0f0448f8ccbc',
    templateIndex: '265',
    title: 'Concrete & Slabs',
    position: 51,
    versions: [
      {
        _id: 'fb9d219c-0c2f-49bb-a7c8-5923f4948635',
        templateIndex: '265',
        title: 'Concrete & Slabs',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'concrete-slabs',
        categories: [],
        src: {
          name: 'concrete-slabs.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e764d9fb-a5bd-41fe-b9d2-d1ca8d920aca',
        templateIndex: '265',
        title: 'Concrete & Slabs Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'concrete-slabs-single-page',
        categories: [],
        src: {
          name: 'concrete-slabs.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '4f3b570e-682b-4331-b4ef-6a72afc4feba',
    templateIndex: '296',
    title: 'Insurance Broker',
    position: 50,
    versions: [
      {
        _id: 'd4aa5d4a-ac5e-456f-a609-2e8f427b424d',
        templateIndex: '296',
        title: 'Insurance Broker',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'insurance-broker',
        categories: [],
        src: {
          name: 'insurance-broker.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8146be8c-26b8-4ed0-850d-798648b7e893',
        templateIndex: '296',
        title: 'Insurance Broker Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'insurance-broker-single-page',
        categories: [],
        src: {
          name: 'insurance-broker-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: 'a9271358-4ab0-4f26-9487-3b828659ee65',
    templateIndex: '183',
    title: 'Beauty Store',
    position: 49,
    versions: [
      {
        _id: 'a9271358-4ab0-4f26-9487-3b828659ee65',
        templateIndex: '183',
        title: 'Beauty Store Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'beauty-store-single-page',
        categories: [],
        src: {
          name: 'beauty-store.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'beauty-store.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['en'],
  },
  {
    _id: '7b25c500-174a-4aad-b691-910691a23dd1',
    templateIndex: '179',
    title: 'Vineyard',
    position: 48,
    versions: [
      {
        _id: '7b25c500-174a-4aad-b691-910691a23dd1',
        title: 'Vineyard',
        templateIndex: '179',
        type: 'multiPages',
        link: 'grape-farm',
        categories: [
          '574ec0f301e9d73bfb5d9937',
          '58637d12d7bf940e2080e185',
          '574ec22301e9d73bfb5d993c',
        ],
        src: {
          name: 'grape-farm.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '96f5f178-4d3f-47fb-acfa-bc202025f149',
        versionName: 'onePage',
        title: 'Vineyard Single-Page',
        templateIndex: '179',
        type: 'onePage',
        link: 'grape-farm-single-page',
        categories: [],
        src: {
          name: 'grape-farm.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Business', 'All', 'Services'],
    src: {
      name: 'grape-farm.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '7258cd93-6176-4459-bf95-5f2af4c99a48',
    templateIndex: '259',
    title: 'Dance Studio',
    position: 47,
    versions: [
      {
        _id: '84b46338-2802-401c-bb9e-4a57ba985ca6',
        templateIndex: '259',
        title: 'Dance Studio',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'dance-studio',
        categories: [],
        src: {
          name: 'dance-studio.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '12a8d1fc-7130-40f8-b8f9-e6f20d1bb2fa',
        templateIndex: '259',
        title: 'Dance Studio Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'dance-studio-single-page',
        categories: [],
        src: {
          name: 'dance-studio.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '145e1232-336f-4421-a3dc-16261e11dcb8',
    templateIndex: '176',
    title: 'Blinds',
    position: 46,
    versions: [
      {
        _id: '145e1232-336f-4421-a3dc-16261e11dcb8',
        title: 'Blinds',
        templateIndex: '176',
        type: 'multiPages',
        link: 'blinds',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'blinds.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'd4308705-a52e-4ab6-a1ba-771064274e29',
        versionName: 'onePage',
        title: 'Blinds Single-Page',
        templateIndex: '176',
        type: 'onePage',
        link: 'blinds-single-page',
        categories: [],
        src: {
          name: 'blinds-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'blinds.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '4d8ba875-b271-4c85-b037-0f39df6885c3',
    templateIndex: '246',
    title: 'Personal Trainer Gym',
    position: 45,
    versions: [
      {
        _id: '7610c72b-558c-452d-8055-a06179d06f29',
        templateIndex: '246',
        title: 'Personal Trainer Gym',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'personal-trainer-gym',
        categories: [],
        src: {
          name: 'personal-trainer-gym.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'cc0a7ad3-adca-459c-a46d-2dfa0556dd06',
        templateIndex: '246',
        title: 'Personal Trainer Gym Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'personal-trainer-gym-single-page',
        categories: [],
        src: {
          name: 'personal-trainer-gym-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '1e03d562-2e24-4abc-b5ef-e8585608acc0',
    templateIndex: '267',
    title: 'Tattoo Studio',
    position: 44,
    versions: [
      {
        _id: 'd55e69d7-a4d3-4e59-a2c9-15678ce55022',
        templateIndex: '267',
        title: 'Tattoo Studio',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'tattoo-studio',
        categories: [],
        src: {
          name: 'tattoo-studio.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '0c800670-b8d6-46ac-a5cb-55e4c43dd264',
        templateIndex: '267',
        title: 'Tattoo Studio Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'tattoo-studio-single-page',
        categories: [],
        src: {
          name: 'tattoo-studio-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    locale: ['en'],
  },
  {
    _id: 'e8d11af4-c927-4869-be8d-dee247a64c03',
    templateIndex: '167',
    title: 'Bike Event',
    position: 43,
    versions: [
      {
        _id: 'e8d11af4-c927-4869-be8d-dee247a64c03',
        title: 'Bike Event',
        templateIndex: '167',
        type: 'multiPages',
        link: 'tour-event',
        categories: ['574ec22301e9d73bfb5d993c', '58637d12d7bf940e2080e185'],
        src: {
          name: 'tour-event.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '6e789aef-4289-49cb-9885-dc36449a4438',
        versionName: 'onePage',
        title: 'Bike Event Single-Page',
        templateIndex: '167',
        type: 'onePage',
        link: 'tour-event-single-page',
        categories: [],
        src: {
          name: 'tour-event.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Services', 'All'],
    src: {
      name: 'tour-event.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '408b7fc6-a9a2-4894-8abf-a5619078fb33',
    templateIndex: '241',
    title: 'Kitchen & Wardrobes',
    position: 42,
    versions: [
      {
        _id: 'da904145-4714-4104-86b0-47a3bcfbb76c',
        templateIndex: '241',
        title: 'Kitchen & Wardrobes',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'kitchen-wardrobes',
        categories: [],
        src: {
          name: 'kitchen-wardrobes.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '6b455d71-0678-47b9-8c61-809aa8c96c89',
        templateIndex: '241',
        title: 'Kitchen & Wardrobes Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'kitchen-wardrobes-single-page',
        categories: [],
        src: {
          name: 'kitchen-wardrobes-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '52e3991e-1369-4717-b460-d105f5a8edfb',
    templateIndex: '237',
    title: 'Hair Salon',
    position: 41,
    versions: [
      {
        _id: '6c787d89-7bb6-4721-9ab5-d9e691dc72d3',
        templateIndex: '237',
        title: 'Hair Salon',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'hair-salon',
        categories: [],
        src: {
          name: 'hair-salon.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '99ec0c2b-b9db-4d42-99b0-9038fe11485b',
        templateIndex: '237',
        title: 'Hair Salon Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'hair-salon-single-page',
        categories: [],
        src: {
          name: 'hair-salon-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Beauty'],
    locale: ['en'],
  },
  {
    _id: '7703ea9a-c1e3-45da-82a4-0e9b85469677',
    templateIndex: '247',
    title: 'Logistics & Freight',
    position: 40,
    versions: [
      {
        _id: 'ca5e64f0-d984-4c14-89d6-5c1f9e40d8f8',
        templateIndex: '247',
        title: 'Logistics & Freight',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'logistics-freight',
        categories: [],
        src: {
          name: 'logistics-freight.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '8dd0fe8b-0217-4254-8e9b-c3dbe65a0cf4',
        templateIndex: '247',
        title: 'Logistics & Freight Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'logistics-freight-single-page',
        categories: [],
        src: {
          name: 'logistics-freight.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '1f695adb-2a5a-4392-ac7f-8b9ef798882b',
    templateIndex: '238',
    title: 'Tailor Shop',
    position: 39,
    versions: [
      {
        _id: '1fcc4311-01d7-4152-aaa7-4db541af252b',
        templateIndex: '238',
        title: 'Tailor Shop',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'tailor-shop',
        categories: [],
        src: {
          name: 'tailor-shop.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '54700d8c-c351-42a6-adfa-626936963c36',
        templateIndex: '238',
        title: 'Tailor Shop Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'tailor-shop-single-page',
        categories: [],
        src: {
          name: 'tailor-shop-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '769e1809-9c22-4298-92c5-8e44ed05f5c1',
    templateIndex: '120',
    title: 'Dentist',
    position: 38,
    versions: [
      {
        _id: '769e1809-9c22-4298-92c5-8e44ed05f5c1',
        title: 'Dentist',
        templateIndex: '120',
        type: 'multiPages',
        link: 'dentist',
        categories: ['574ec22301e9d73bfb5d993c', '58637d12d7bf940e2080e185'],
        src: {
          name: 'dentist.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: '1a9f3bec-9914-4f13-bb54-37bb2044db98',
        versionName: 'onePage',
        title: 'Dentist Single-Page',
        templateIndex: '120',
        type: 'onePage',
        link: 'dentist-single-page',
        categories: [],
        src: {
          name: 'dentist.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['Services', 'All'],
    src: {
      name: 'dentist.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '26df20d8-f206-431f-b997-7019809e479c',
    templateIndex: '230',
    title: 'Glass Repairs',
    position: 37,
    versions: [
      {
        _id: 'a8e4bfad-0c7b-447d-9e8e-fd184d9d6920',
        templateIndex: '230',
        title: 'Glass Repairs',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'glass-repairs',
        categories: [],
        src: {
          name: 'glass-repairs.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '4f4c3e01-6ee3-4faf-a2ff-29ef6120993a',
        templateIndex: '230',
        title: 'Glass Repairs Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'glass-repairs-single-page',
        categories: [],
        src: {
          name: 'glass-repairs-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services'],
    locale: ['en'],
  },
  {
    _id: '45cd338e-35c1-4728-8683-256b40869f8e',
    templateIndex: '173',
    title: 'Tyre Repairs',
    position: 36,
    versions: [
      {
        _id: '45cd338e-35c1-4728-8683-256b40869f8e',
        title: 'Tyre Repairs',
        templateIndex: '173',
        type: 'multiPages',
        link: 'tyre-repairs',
        categories: ['58637d12d7bf940e2080e185', '574ec0f301e9d73bfb5d9937'],
        src: {
          name: 'tyre-repairs.jpg',
          path: '/assets/image',
        },
        versionName: 'multiPages',
      },
      {
        _id: 'c621355b-613c-4c5e-bb37-06895630a118',
        versionName: 'onePage',
        title: 'Tyre Repairs Single-Page',
        templateIndex: '173',
        type: 'onePage',
        link: 'tyre-repairs-single-page',
        categories: [],
        src: {
          name: 'tyre-repairs.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'tyre-repairs.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['en'],
  },
  {
    _id: '505890e6-9505-4f9c-a43c-263f7bd4c906',
    templateIndex: '242',
    title: 'Storage',
    position: 35,
    versions: [
      {
        _id: '95ff49b3-7893-4e92-9e76-cd34673ef9f6',
        templateIndex: '242',
        title: 'Storage',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'storage',
        categories: [],
        src: {
          name: 'storage.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'a8dfab3e-a2f9-4690-a89c-e3488f266ad4',
        templateIndex: '242',
        title: 'Storage Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'storage-single-page',
        categories: [],
        src: {
          name: 'storage-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    locale: ['en'],
  },
  {
    _id: '640f8fde-44f5-4270-af97-c19e0910d309',
    templateIndex: '227',
    title: 'Juan dela Cruz',
    position: 0,
    versions: [
      {
        _id: '640f8fde-44f5-4270-af97-c19e0910d309',
        templateIndex: '227',
        title: 'Juan dela Cruz',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'juan-dela-cruz',
        categories: [],
        src: {
          name: 'juan-dela-cruz.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'aaf559b7-8163-42c9-ae00-5ff514da1d48',
        templateIndex: '227',
        title: 'Juan dela Cruz Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'juan-dela-cruz-single-page',
        categories: [],
        src: {
          name: 'juan-dela-cruz-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Portfolio'],
    src: {
      name: 'juan-dela-cruz.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: 'f80318f8-ac06-4ab7-9467-5659ed66a30d',
    templateIndex: '218',
    title: 'FURever Pet Shop',
    position: 0,
    versions: [
      {
        _id: 'f80318f8-ac06-4ab7-9467-5659ed66a30d',
        templateIndex: '218',
        title: 'FURever Pet Shop',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'furever-pet-shop',
        categories: [],
        src: {
          name: 'furever-pet-shop.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'fd85e649-44ff-41c5-a362-3b17c4d39a66',
        templateIndex: '218',
        title: 'Kalinga Cafe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'furever-pet-shop-single-page',
        categories: [],
        src: {
          name: 'furever-pet-shop-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services', 'Health'],
    src: {
      name: 'furever-pet-shop.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '37d4da6b-13bd-4f9c-b20b-19c94b80ca9c',
    templateIndex: '213',
    title: 'Sakay App',
    position: 0,
    versions: [
      {
        _id: '37d4da6b-13bd-4f9c-b20b-19c94b80ca9c',
        templateIndex: '213',
        title: 'Sakay App',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'sakay-app',
        categories: [],
        src: {
          name: 'sakay-app.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'e6e7537c-a281-474d-b16c-489527d67265',
        templateIndex: '213',
        title: 'Sakay App Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'sakay-app-single-page',
        categories: [],
        src: {
          name: 'sakay-app-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'sakay-app.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '173e5798-9d3f-465a-82b9-af0e7737d62c',
    templateIndex: '215',
    title: 'Panlasang Noypi',
    position: 0,
    versions: [
      {
        _id: '173e5798-9d3f-465a-82b9-af0e7737d62c',
        templateIndex: '215',
        title: 'Panlasang Noypi',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'panlasang-noypi',
        categories: [],
        src: {
          name: 'panlasang-noypi.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '3e2de5d6-b675-4ea7-b3c4-05e570f9e97a',
        templateIndex: '215',
        title: 'Panlasang Noypi Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'panlasang-noypi-single-page',
        categories: [],
        src: {
          name: 'panlasang-noypi-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Personal'],
    src: {
      name: 'panlasangnoypi.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '53ee7490-e15f-4050-a2c5-cbbf224c8846',
    templateIndex: '219',
    title: 'Alamat Brewing Co.',
    position: 0,
    versions: [
      {
        _id: '53ee7490-e15f-4050-a2c5-cbbf224c8846',
        templateIndex: '219',
        title: 'Alamat Brewing Co.',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'alamat-brewing-co',
        categories: [],
        src: {
          name: 'alamat-brewing-co.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '18d76eaf-8a37-4c7e-8d1a-29aefe8f7054',
        templateIndex: '219',
        title: 'Alamat Brewing Co. Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'alamat-brewing-co-single-page',
        categories: [],
        src: {
          name: 'alamat-brewing-co-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business', 'Restaurant'],
    src: {
      name: 'alamat-brewing-co.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '111e12b0-b4b0-4d42-afe6-b6e91c9f93fd',
    templateIndex: '214',
    title: 'Marikina Shoes',
    position: 0,
    versions: [
      {
        _id: '111e12b0-b4b0-4d42-afe6-b6e91c9f93fd',
        templateIndex: '214',
        title: 'Marikina Shoes Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'marikina-shoes-single-page',
        categories: [],
        src: {
          name: 'marikina-shoes-single-page.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'marikina-shoes-singlepage.jpg',
      path: '/assets/image',
    },
    type: 'onePage',
    versionName: 'onePage',
    locale: ['ph'],
  },
  {
    _id: '73dfd559-e8b7-471b-bc76-0c0aec2e2f41',
    templateIndex: '216',
    title: 'BizVibe',
    position: 0,
    versions: [
      {
        _id: '73dfd559-e8b7-471b-bc76-0c0aec2e2f41',
        templateIndex: '216',
        title: 'BizVibe',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'bizvibe',
        categories: [],
        src: {
          name: 'bizvibe.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: 'c12a3db3-af48-4afa-b3ce-9c7ee7028d8c',
        templateIndex: '216',
        title: 'BizVibe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'bizvibe-single-page',
        categories: [],
        src: {
          name: 'bizvibe-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'bizvibe.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '44e1aab6-55b5-4150-8d47-bb89fa978fdb',
    templateIndex: '229',
    title: 'ConstructionPro',
    position: 0,
    versions: [
      {
        _id: '44e1aab6-55b5-4150-8d47-bb89fa978fdb',
        templateIndex: '229',
        title: 'ConstructionPro',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'constructionpro',
        categories: [],
        src: {
          name: 'constructionpro.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '81558e76-205f-48f7-bf29-fbbce8633c27',
        templateIndex: '229',
        title: 'ConstructionPro Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'constructionpro-single-page',
        categories: [],
        src: {
          name: 'constructionpro-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Business'],
    src: {
      name: 'constructionpro.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: 'cf994a6f-3971-4254-ae99-7027193eb304',
    templateIndex: '225',
    title: 'Pinoy Fitness',
    position: 0,
    versions: [
      {
        _id: 'cf994a6f-3971-4254-ae99-7027193eb304',
        templateIndex: '225',
        title: 'Pinoy Fitness',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'pinoy-fitness',
        categories: [],
        src: {
          name: 'pinoy-fitness.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '1b12e803-885e-49f2-af5e-569bc1f0f0c5',
        templateIndex: '225',
        title: 'Pinoy Fitness Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'pinoy-fitness-single-page',
        categories: [],
        src: {
          name: 'pinoy-fitness-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Health'],
    src: {
      name: 'pinoy-fitness.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
  {
    _id: '290bfd03-dfcd-407b-8b1e-21171e977037',
    templateIndex: '217',
    title: 'Kalinga Cafe',
    position: 0,
    versions: [
      {
        _id: '290bfd03-dfcd-407b-8b1e-21171e977037',
        templateIndex: '217',
        title: 'Kalinga Cafe',
        versionName: 'multiPages',
        type: 'multiPages',
        link: 'kalinga-cafe',
        categories: [],
        src: {
          name: 'kalinga-cafe.jpg',
          path: '/assets/image',
        },
      },
      {
        _id: '9981109d-0ee3-4774-98f4-7b3e67663534',
        templateIndex: '217',
        title: 'Kalinga Cafe Single-Page',
        versionName: 'onePage',
        type: 'onePage',
        link: 'kalinga-cafe-single-page',
        categories: [],
        src: {
          name: 'kalinga-cafe-singlepage.jpg',
          path: '/assets/image',
        },
      },
    ],
    categories: ['All', 'Services', 'Health'],
    src: {
      name: 'kalinga-cafe.jpg',
      path: '/assets/image',
    },
    type: 'multiPages',
    versionName: 'multiPages',
    locale: ['ph'],
  },
];
/* eslint-enable no-dupe-keys */
